import { useContext } from "react";
import { Link } from "react-router-dom";
import { LanguageContext } from "./LanguageContext";
import it from "../translations/it.json";
import en from "../translations/en.json";

const NotFound = () => {
  const { language, setLanguage } = useContext(LanguageContext);
  const translations = language === "it" ? it : en;

  return (
    <>
      <div
        style={{
          background: "linear-gradient(135deg, #000000, #1a1a1a)",
          color: "#fff",
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: "2rem",
        }}
      >
        <div className="d-flex align-items-center">
          <img
            src="/assets/it.webp"
            alt="Italiano"
            style={{
              width: "30px",
              height: "20px",
              cursor: "pointer",
              marginRight: "10px",
            }}
            onClick={() => setLanguage("it")}
          />
          <img
            src="/assets/en.webp"
            alt="English"
            style={{ width: "30px", height: "20px", cursor: "pointer" }}
            onClick={() => setLanguage("en")}
          />
        </div>
        <div style={{ padding: "2rem", textAlign: "center" }}>
          <h1>{translations.notFound.title}</h1>
          <p>{translations.notFound.description}</p>
          <Link to="/" style={{ color: "#fff" }}>
            {translations.notFound.linkHome}
          </Link>
        </div>
      </div>
    </>
  );
};

export default NotFound;
